export const parseApprovalResponse = (response) => {
  const body = response?.data ?? {};
  const pendingApproval =
    response?.status === 202 ||
    body?.status === 202 ||
    body?.approval_required === true;
  const approvalRequestId =
    body?.approval_request_id ?? body?.data?.approval_request_id ?? null;
  const message = body?.message ?? null;
  return {
    pendingApproval,
    approvalRequestId,
    message,
    data: body?.data ?? body,
  };
};

export const apiErrorMessage = (error, fallback = "Request failed.") =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  fallback;

/** Retry a gated action after approval using stored payload + approval_request_id */
export const ENTITY_APPLY_ENDPOINTS = {
  landlord_payout: {
    CREATE: { method: "post", path: "/admin/landlord_payments" },
  },
  rental_payment_custom: {
    CREATE: { method: "post", path: "/tenants/payments/custom" },
  },
  tenant_end_tenancy: {
    CREATE: { method: "post", path: "/landlords/rentals/units/remove" },
  },
};

export const getEntityApplyUrl = (entityCode, action, baseUrl, adminBaseUrl) => {
  const endpoint = ENTITY_APPLY_ENDPOINTS[entityCode]?.[action];
  if (!endpoint) return null;
  if (endpoint.path.startsWith("/admin/")) {
    return `${adminBaseUrl}${endpoint.path.replace(/^\/admin/, "")}`;
  }
  return `${baseUrl}${endpoint.path}`;
};
